var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dp-page-header': true,
    'dp-page-header--flexible-height': _vm.flexibleHeight,
    'dp-page-header--attach-to-top': _vm.attachToTop,
  }},[_c('dp-container',{staticClass:"dp-page-header__inner"},[_c('dp-control-group',{attrs:{"spread":""}},[_c('dp-control-group',[_vm._t("default")],2),(_vm.$slots.right)?_c('dp-control-group',{attrs:{"right-aligned":""}},[_vm._t("right")],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }